export const PullToRefreshIndicator = ({
  pullDistance,
  isRefreshing,
  threshold = 80,
}) => {
  const progress = Math.min(pullDistance / threshold, 1);
  const opacity = Math.min(pullDistance / (threshold * 0.5), 1);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 pointer-events-none overflow-hidden"
      style={{
        height: `${Math.max(pullDistance, 0)}px`,
        transition:
          isRefreshing || pullDistance === 0
            ? "height 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)"
            : "none",
      }}
    >
      <div className="flex items-center justify-center h-full">
        {/* Spinner/Loading indicator */}
        <div className="flex flex-col items-center gap-2">
          {/* Animated icon */}
          <div
            className="relative w-8 h-8"
            style={{
              transform: `rotate(${progress * 180}deg)`,
              transition: isRefreshing ? "none" : "transform 0.1s",
            }}
          >
            <svg
              className="w-full h-full text-emerald-400"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>

          {/* Progress indicator */}
          {!isRefreshing && progress < 1 && (
            <div className="text-xs text-slate-400 font-medium">
              {Math.round(progress * 100)}%
            </div>
          )}

          {/* Refreshing state */}
          {isRefreshing && (
            <div className="text-xs text-emerald-400 font-medium animate-pulse">
              Refreshing...
            </div>
          )}
        </div>
      </div>

      {/* Background gradient */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-slate-900/40 to-transparent pointer-events-none"
        style={{ opacity }}
      />
    </div>
  );
};
